import React, { useState, useCallback } from 'react';
import { Tab } from 'semantic-ui-react';

import GuaranteePurchases from './GuaranteePurchases';
import CancelledGuaranteePurchases from './CancelledGuaranteePurchases';
import IneligiblePurchases from './IneligiblePurchases';
import GuaranteeProductSelector from '../components/GuaranteeProductSelector';
import GuaranteePanel from '../components/GuaranteePanel';
import { GUARANTEES_V2_ENABLED } from '../config';
import { useGuaranteeTheme } from '../hooks/useGuaranteePurchases';

const GuaranteePurchasesTabs = () => {
  const themeClass = useGuaranteeTheme();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = useCallback((e, { activeIndex }) => {
    setActiveTabIndex(activeIndex);
  }, []);

  if (!GUARANTEES_V2_ENABLED) {
    const panes = [
      {
        menuItem: 'Guarantee Purchases',
        render: () => (
          <Tab.Pane>
            {' '}
            <GuaranteePurchases />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Canceled Purchases',
        render: () => (
          <Tab.Pane>
            <CancelledGuaranteePurchases />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div>
        {' '}
        <Tab panes={panes} />
      </div>
    );
  }

  const panes = [
    {
      menuItem: 'Guarantee Purchases',
      render: () => (
        <Tab.Pane>
          <GuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Cancelled Purchases',
      render: () => (
        <Tab.Pane>
          <CancelledGuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Ineligible Purchases',
      render: () => (
        <Tab.Pane>
          <IneligiblePurchases />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div
      style={{ marginTop: '-56px' }}
      className={themeClass}
    >
      <GuaranteePanel>
        <GuaranteeProductSelector />
      </GuaranteePanel>
      <Tab
        panes={panes}
        activeIndex={activeTabIndex}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default GuaranteePurchasesTabs;
